import { Routes } from '@angular/router';
import { cloudOnlyGuard, guestGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () => import('./pages/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      {
        path: 'provision',
        loadComponent: () =>
          import('./pages/welcome/welcome.component').then((m) => m.WelcomeComponent),
      },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
          },
          {
            path: 'ota',
            canActivate: [cloudOnlyGuard],
            loadComponent: () =>
              import('./pages/ota-releases/ota-releases.component').then((m) => m.OtaReleasesComponent),
          },
          {
            path: 'installations',
            loadComponent: () =>
              import('./pages/installations/installations.component').then(
                (m) => m.InstallationsComponent,
              ),
          },
          {
            path: 'installations/:id',
            loadComponent: () =>
              import('./pages/installation-detail/installation-detail.component').then(
                (m) => m.InstallationDetailComponent,
              ),
          },
          {
            path: 'installations/:id/add-thermostat',
            loadComponent: () =>
              import('./pages/installations/add-thermostat/add-thermostat.component').then(
                (m) => m.AddThermostatComponent,
              ),
          },
          {
            path: 'installations/:installationId/zones/:mac',
            loadComponent: () =>
              import('./pages/zone-detail/zone-detail.component').then((m) => m.ZoneDetailComponent),
          },
          {
            path: 'installations/:installationId/config',
            loadComponent: () =>
              import('./pages/config/rooms-config/rooms-config.component').then(
                (m) => m.RoomsConfigComponent,
              ),
          },
          {
            path: 'installations/:installationId/config/rooms/:roomId',
            loadComponent: () =>
              import('./pages/config/room-config-detail/room-config-detail.component').then(
                (m) => m.RoomConfigDetailComponent,
              ),
          },
          {
            path: 'central/:uuid',
            loadComponent: () =>
              import('./pages/central-detail/central-detail.component').then((m) => m.CentralDetailComponent),
          },
          {
            path: 'settings',
            loadComponent: () =>
              import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
